import { motion, useReducedMotion } from 'framer-motion'
import { Home, LayoutGrid, FolderGit2, MessageCircle } from 'lucide-react'
import useActiveSection from '../../hooks/useActiveSection'
import { scrollToSection } from '../../utils/helpers'
import { BOTTOM_NAV_ITEMS } from '../../utils/constants'
import { SPRING } from '../../utils/motion'

const ICONS = { Home, LayoutGrid, FolderGit2, MessageCircle }

// Section ids are a stable module-level array so useActiveSection's effect deps
// don't change every render.
const SECTION_IDS = BOTTOM_NAV_ITEMS.map((i) => i.id)

/* Mobile-only navigation bar. The active tab is marked by a teal bar along
   the top edge that slides to whichever tab is selected. */
const BottomNav = () => {
  const activeId = useActiveSection(SECTION_IDS)
  const reduce = useReducedMotion()

  return (
    <nav
      role="navigation"
      aria-label="Primary"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 border-t border-outline-variant/60 bg-sc-lowest/95 backdrop-blur-xl
                 shadow-[0_-8px_24px_-18px_rgb(var(--shadow-hue)/0.35)] pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="flex items-stretch justify-around px-2 pt-2 pb-1">
        {BOTTOM_NAV_ITEMS.map((item) => {
          const Icon = ICONS[item.icon]
          const isActive = activeId === item.id
          return (
            <li key={item.id} className="flex-1">
              <motion.button
                onClick={() => scrollToSection(item.id)}
                aria-current={isActive ? 'page' : undefined}
                aria-label={item.label}
                whileTap={reduce ? undefined : { scale: 0.96 }}
                transition={SPRING.snappy}
                className="relative flex w-full min-h-[52px] flex-col items-center justify-center gap-1"
              >
                {isActive && (
                  <motion.span
                    layoutId="bottomnav-bar"
                    className="absolute -top-2 h-0.5 w-10 bg-primary"
                    transition={reduce ? { duration: 0 } : SPRING.snappy}
                  />
                )}
                <span className="relative flex h-7 items-center justify-center">
                  <span className={`relative ${isActive ? 'text-primary' : 'text-ink-3'}`}>
                    <Icon className="h-5 w-5" strokeWidth={isActive ? 2.25 : 1.75} />
                  </span>
                </span>
                <span
                  className={`text-[11px] tracking-wide transition-colors duration-200 ${
                    isActive ? 'font-bold text-ink' : 'font-medium text-ink-3'
                  }`}
                >
                  {item.label}
                </span>
              </motion.button>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default BottomNav
